import React, { FC, useContext } from 'react';
import find from 'lodash/find';

import { AsyncDropdownMenu } from 'src/presentation/components/agent_desktop_components';
import FieldContainer from './FieldContainer';
import FormContext from 'src/presentation/contexts/FormContext';
import getErrorMessage from './getErrorMessage';

type AsyncDropdownProps = {
  'data-aid'?: string;
  delay: number;
  attr?: string;
  className?: string;
  description?: string;
  label?: string;
  knownItems?: Record<string, string>;
  maxRows?: number;
  onChange: Function;
  onSearch: Function;
  options?: any[];
  placeholder?: string;
  text?: string;
  value?: string | boolean;
};

const AsyncDropdown: FC<AsyncDropdownProps> = ({
  'data-aid': dataAid = null,
  delay,
  attr,
  className,
  description,
  knownItems = null,
  label,
  maxRows,
  onChange,
  onSearch,
  options,
  placeholder,
  text,
  value,
}) => {
  const { errors } = useContext(FormContext);
  const error = find(errors, error => error.attr === attr);

  return (
    <FieldContainer
      error={error ? getErrorMessage(error, label) : undefined}
      label={label}
      description={description}
      data-aid={dataAid}
      control={
        <AsyncDropdownMenu
          data-aid={dataAid}
          delay={delay}
          isError={!!error}
          labelsHash={knownItems}
          maxRows={maxRows}
          options={options}
          onSearch={onSearch}
          onSelect={onChange}
          placeholder={placeholder}
          text={text}
          value={value}
          className={error ? `${className} invalid` : className}
        />
      }
    />
  );
};

export default AsyncDropdown;
